import { html } from 'fxjs/es';

export const buyLaterProductEditColumnTmpl = () => {
  return html`
    <button class="omp-my-wish__add-to-cart">${TT('my_page::wish::wish_11')}</button>
    <button class="omp-my-wish__product-delete">${TT('common::delete')}</button>
  `;
};
